module.exports = __webpack_public_path__ + "static/media/popover_Bankquota.e9ae06b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/popover_Bankquota.png
// module id = 1844
// module chunks = 0 1